/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";
import { getData } from "../../Services/getData";
import { urlEnum } from "../../Utils/UrlEnum";
import { toast } from "react-toastify";
import { updateData } from "../../Services/updateData";

const priorities = [
  { name: "NORMAL", label: Vocabulary.normal },
  { name: "HIGHER", label: Vocabulary.higher },
  { name: "HIGHEST", label: Vocabulary.highest },
];

export default function PriorityColors() {
  const [colors, setColors] = useState<Record<string, string>>({
    NORMAL: "#ffffff",
    HIGHER: "#ffffff",
    HIGHEST: "#ffffff",
  });

  useEffect(() => {
    getData(urlEnum.priorityColors).then((res: any) => {
      if (res?.data?.result) {
        const newColors: Record<string, string> = { ...colors };
        res.data.result.forEach((pc: any) => {
          newColors[pc.priority] = pc.color;
        });
        setColors(newColors);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleColorChange(priority: string, color: string) {
    setColors({ ...colors, [priority]: color });
  }

  function handleSave() {
    const payload = Object.entries(colors).map(([priority, color]) => ({
      priority,
      color,
    }));
    updateData(urlEnum.priorityColors, payload).then((res: any) => {
      if (res?.data?.result) {
        toast.success(Vocabulary.priorityColorsSaved);
      }
    });
  }

  return (
    <>
      <div style={{ marginTop: 50 }}></div>
      <Paper sx={{ p: 3, maxWidth: 500 }}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>{Vocabulary.priority}</TableCell>
                <TableCell>{Vocabulary.color || "Color"}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {priorities.map((p) => (
                <TableRow key={p.name}>
                  <TableCell>{p.label}</TableCell>
                  <TableCell>
                    <input
                      type="color"
                      value={colors[p.name]}
                      onChange={(e) =>
                        handleColorChange(p.name, e.target.value)
                      }
                      style={{
                        width: 50,
                        height: 35,
                        border: "none",
                        cursor: "pointer",
                        padding: 0,
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
          <Button variant="contained" onClick={handleSave}>
            {Vocabulary.save}
          </Button>
        </Box>
      </Paper>
    </>
  );
}
